// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React, { Suspense, useEffect } from 'react'
import { object } from 'prop-types'
import { useDispatch } from 'react-redux'
import GlobalErrorBoundary from './GlobalErrorBoundary'
import Home from './Home'
import PageNotFound from './PageNotFound'
import lego_authentication_broadcast_channel from 'broadcastChannels/lego_authentication_broadcast_channel'
import syncAuthenticationBroadcastChannelWithRedux from 'redux/modules/user/thunks/syncAuthenticationBroadcastChannelWithRedux'
import SystemMaintenanceCheck from './SystemMaintenanceCheck'

import {
  Router,
  Route,
  Switch,
} from 'react-router-dom'

import {
  ReduxNotifications,
  LoadingIcon,
  AuthRoute,
  AuthWrapper,
  ConnectedLoader,
  ModalContextProvider,
  Navigation,
} from 'components'


const DatabaseManagement = React.lazy(() => import('./DatabaseManagement'))
const Login = React.lazy(() => import('./Login'))
const ProjectManagement = React.lazy(() => import('./ProjectManagement'))
const ProtectionProject = React.lazy(() => import('./ProtectionProject'))

// Routes is wrapped in AuthWrapper which, on application load checks localStorage for the user's JWT.
// if not found or invalid it redirects the user to the /login screen.
// AuthRoute on the other hand is used as a check for each page.
// For example, if we're at /login, the app has already loaded, so AuthWrapper will not capture a change in url.
// So AuthRoute checks redux state to see if the user is authorized, if not, redirect them to /login
const Routes = ({ history }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const onMessage = event => dispatch(syncAuthenticationBroadcastChannelWithRedux(event.data))
    lego_authentication_broadcast_channel.addEventListener('message', onMessage)

    return () => {
      lego_authentication_broadcast_channel.removeEventListener('message', onMessage)
    }
  }, [])

  return (
    <GlobalErrorBoundary>
        <AuthWrapper>
          <Router history={history}>
            <ModalContextProvider>
              <Suspense
                fallback={(
                  <LoadingIcon loading={true} />
                )}>
                <SystemMaintenanceCheck>
                  <Navigation />
                  <div className={'page-wrapper'}>
                    <Switch>
                      <AuthRoute
                        component={Home}
                        exact={true}
                        path={'/'} />
                      <Route
                        component={Login}
                        exact={true}
                        path={'/login'} />
                      <AuthRoute
                        component={ProjectManagement}
                        path={'/project-management'} />
                      <AuthRoute
                        component={ProtectionProject}
                        path={'/protection-project-by-rcn'} />
                      <AuthRoute
                        component={DatabaseManagement}
                        path={'/database-management'} />
                      <AuthRoute
                        component={PageNotFound}
                        path={'*'} />
                    </Switch>
                  </div>
                  <ReduxNotifications />
                  <ConnectedLoader />
                </SystemMaintenanceCheck>
              </Suspense>
            </ModalContextProvider>
          </Router>
        </AuthWrapper>
    </GlobalErrorBoundary>
  )
}

Routes.propTypes = {
  history: object.isRequired,
}

export default Routes
